
export default {
    methods: {
        handleConflictError(error) {
            this.$root.v2.proposal = {...this.$root.v2.proposal, ...error.data};
        }
    }
}
